import { Navigate } from 'react-router';
import { useHomepageStaticPage } from '../api/queryHooks/account';
import { useLogin } from '../hooks/useLogin';
import { parseBlockDocument } from '../api/staticPageBlocks';
import BlockRenderer from '../components/blocks/BlockRenderer';
import MarkdownContent from '../components/common/MarkdownContent';

const Home = () => {
  const { data, isPending, isError } = useHomepageStaticPage();
  const { isLoggedIn, isGuest, isPending: loginPending } = useLogin();

  if (isPending) return null;

  // 404 (no page designated as homepage) and 403 (logged_in page, anonymous
  // caller) both land here as isError. Without a homepage the shop has no
  // front page of its own: a real logged-in user goes straight to their
  // albums, everyone else (anonymous or guest) to the login page, which
  // carries the album-code entry form. Wait for the login state before
  // choosing, or a returning user would flash through /login first.
  if (isError || !data) {
    if (loginPending) return null;
    return <Navigate to={isLoggedIn && !isGuest ? '/albums' : '/login'} replace />;
  }

  const doc = parseBlockDocument(data.body);
  if (doc) {
    return (
      <div className="home-blocks">
        <BlockRenderer document={doc} />
      </div>
    );
  }

  return (
    <div className="home-blocks">
      <MarkdownContent content={data.body} />
    </div>
  );
};

export default Home;
